import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
// import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// CSS Modules, react-datepicker-cssmodules.css
import 'react-datepicker/dist/react-datepicker-cssmodules.css';
import { makeStyles } from '@material-ui/core/styles';
// import TextField from '@material-ui/core/TextField';
import SelectFix from './../../PopUp/SelectFix';
// import InputAdornment from '@material-ui/core/InputAdornment';

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        fontSize: "small"
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        /* width: 300, */
    },
}));
export default function CustomDateRangePicker(props) {

    const { titleStart, titleEnd, dateEndEnable } = props
    const classes = useStyles();
    const today = new Date();
    const date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    const StartDate = useRef(null);
    const StopDate = useRef(null);

    const SelectSetData = (type, data) => {
        if (data !== "") { 
            // console.log(data);
            switch (type) {
                case "Calendar":
                    StartDate.current.value = data
                    props.startDate(data)
                    break;
                case "Calendar1":
                    StopDate.current.value = data
                    props.endDate(data)
                    break;
                default:
                    break;
            }
        }
    }
    return (
        <div>
            <style jsx>{`
             .MuiInput-underline:before {
                 content: none
             }
             .input-group-addon {
                 height: 35px !important;
             }
             .input-group .form-control, .input-group-addon, .input-group-btn {
                 height: 35px;
             }
             input[type="button"] {
                 margin-top: 5px;
                 margin-left: 5px;
             }
             .MuiInputBase-root.MuiInput-root.MuiInput-underline.MuiInputBase-formControl.MuiInput-formControl.MuiInputBase-adornedStart.MuiInputBase-marginDense.MuiInput-marginDense {
                 width: 98%;
             }
             input#datestart {
                 font-size: 18px;
                 font-family: 'mainfont';
             }
             input#enddate {
                 font-size: 18px;
                 font-family: 'mainfont';
             }
             `}</style>
            <div class="row" style={{ marginBottom: '10px' }}>
                <div class='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12' >
                    <div class="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12" style={{ width: '100%' }}>
                        <span class="input-group-addon" style={{ width: '100px' }}> {titleStart}   </span>
                        <input type="text" class="form-control" ref={StartDate}  />
                        {/* <TextField
                            id="datestart"
                            class="form-control "
                            label=""
                            type="date"
                            style={{ content: 'none !important' }}
                            defaultValue={date}
                            className={classes.textField}
                            // variant="outlined"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            size="small"
                            onChange={e => { props.startDate(e.target.value) }}

                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                       // <h5 style={{backgroundColor:'red'}}>{titleStart}:</h5>
                                    </InputAdornment>
                                ),
                            }}
                        /> */}
                        <span class="input-group-addon icon">
                        <SelectFix type="Calendar" SelectSetData={SelectSetData}/>
                        </span>
                    </div>
                </div>
            </div>
            {dateEndEnable === false ? "" : 
            <div class="row" >
                <div class='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12' >
                    <div class="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12"style={{ width: '100%' }}>
                        <span class="input-group-addon" style={{ width: '100px' }}> {titleEnd}  </span>
                        <input type="text" class="form-control" ref={StopDate} />
                        {/* <TextField
                            id="enddate"
                            label=""
                            type="date"
                            class="form-control "
                            // variant="outlined" 
                            defaultValue={date}
                            className={classes.textField}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            size="small"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start" >
                                    </InputAdornment>
                                ),
                            }}
                            onChange={e => { props.endDate(e.target.value) }}
                            /> */}
                          <span class="input-group-addon icon">
                        <SelectFix type="Calendar1" SelectSetData={SelectSetData}/>
                        </span>  
                    </div>
                </div>
            </div> 
            }
        </div>
    );
}
CustomDateRangePicker.propTypes = {
    titleStart: PropTypes.string,
    titleEnd: PropTypes.string,
    dateEndEnable: PropTypes.bool
}

